import { createAction } from '@reduxjs/toolkit';
import { SmoEnvironment } from '../../../../Models/Smo/SmoEnvironment';
import { SmoMoonType } from '../../../../Models/Smo/SmoMoonType';
import { Optional } from '../../../../Utils/Types';

const setPredictedEnvironment = createAction<Optional<SmoEnvironment>>('SET_PREDICTED_ENVIRONMENT');
const setPredictedMoonName = createAction<string>('SET_PREDICTED_MOON_NAME');
const setFilterBrightness = createAction<{
  brightness: number;
  comparisonMisMatchPercent: number;
  moonType: SmoMoonType;
}>('SET_FILTER_BRIGHTNESS');
const resetFilterBrightness = createAction('RESET_FILTER_BRIGHTNESS');
const readSingleMoonTitle = createAction<HTMLImageElement>('READ_SINGLE_MOON_TITLE');
const readMultiMoonName = createAction<HTMLImageElement>('READ_MULTI_MOON_NAME');

const startVideoAnalysis = createAction<HTMLVideoElement>('START_VIDEO_ANALYSIS');
const stopVideoAnalysis = createAction('STOP_VIDEO_ANALYSIS');
const predictEnvironment = createAction<HTMLImageElement>('PREDICT_ENVIRONMENT');
const predictMultiMoon = createAction<HTMLImageElement>('PREDICT_MULTI_MOON');

const readMoonTitle = createAction<{ image: HTMLImageElement; moonType: SmoMoonType }>('READ_MOON_TITLE');
const readMoonName = createAction<{ image: HTMLImageElement; moonType: SmoMoonType; filterBrightness: number }>(
  'READ_MOON_NAME'
);

export default {
  setPredictedEnvironment,
  setPredictedMoonName,
  setFilterBrightness,
  resetFilterBrightness,
  readMoonTitle,
  readMoonName,
  readSingleMoonTitle,
  readMultiMoonName,
  startVideoAnalysis,
  stopVideoAnalysis,
  predictEnvironment,
  predictMultiMoon
};
